import { graphql } from "gatsby"
import { formatArticles, formatTestimonial } from "utils/prismic"
import { StaticImage } from "gatsby-plugin-image"

import SEO from "components/seo"
import useTranslations from "hooks/useTranslations"

import Testimonials from "components/organisms/somebuddy/Testimonials"
import Contact from "components/organisms/somebuddy/Contact"
import Media from "components/variants/MediaEn"
import Hero from "components/organisms/webinar/Hero"
import RequestButton from "components/molecules/RequestButton"
import WhyUs from "components/organisms/somebuddy/WhyUs"
import SituationsCarousel from "components/organisms/somebuddy/SituationsCarousel"
import ValueProposition from "components/organisms/somebuddy/ValueProposition"
import LogoCloudAnimated from "components/organisms/LogoCloudAnimated"
import WaitingListPopup from "components/molecules/WaitingListPopup"

import "styles/index.global.css"

const HeroImage = () => (
  <StaticImage src="./images/schools/istockphoto-471947429.jpeg" alt="" />
)

const IndexPage = ({ data }) => {
  const { coverTitle, coverSubTitle1, credibilityTitle, credibilitySubtitle } =
    useTranslations()
  const prismicArticles =
    data && data.allPrismicNewsArticle
      ? data.allPrismicNewsArticle
      : { edges: [] }
  const articles = formatArticles(prismicArticles)

  const testimonials = data.allPrismicTestimonial.nodes.map((t) =>
    formatTestimonial({ id: t.uid, ...t.data }),
  )

  return (
    <>
      <SEO />
      {/* AI Compass waiting-list modal, switched off. The component honours
          `enabled` in both its effect and its render, so this stops the timer
          as well as the dialog. Flip back to re-run the campaign. */}
      <WaitingListPopup enabled={false} />
      <div className="sections">
        <Hero
          title={coverTitle}
          description={coverSubTitle1}
          descriptionBelow
          bgColor="green"
          Image={HeroImage}
          video="/hero-video.mp4"
          showButton
          HeroButton={RequestButton}
          poster="/hero-poster-small.webp"
        />
        <WhyUs />

        <SituationsCarousel />
        {/* <Problems /> */}
        {/* <Solutions /> */}
        <ValueProposition />
        <LogoCloudAnimated
          currentPage="somebuddy"
          center
          rows={2}
          showArrows={false}
          title={credibilityTitle}
          subtitle={credibilitySubtitle}
        />

        {/* <Segments /> */}
        {/* <Service /> */}
        <Testimonials list={testimonials} />
        {/* <Company /> */}
        <Contact />
        <Media articles={articles} theme="light" />
      </div>
    </>
  )
}

export default IndexPage

export const pageQuery = graphql`
  query ($locale: String!, $currentPage: String!) {
    allPrismicNewsArticle(
      sort: { data: { published_at: DESC } }
      limit: 3
      filter: { lang: { eq: "en-us" } }
    ) {
      edges {
        node {
          id
          data {
            article {
              text
            }
            published_at(formatString: "DD.MM.YYYY")
            link_to_article {
              url
            }
            publisher_logo {
              url
            }
            publisher_name {
              text
            }
          }
        }
      }
    }
    allPrismicFaq(
      sort: { data: { index: ASC } }
      filter: {
        lang: { eq: $locale }
        data: { show_on_pages: { elemMatch: { page: { eq: $currentPage } } } }
      }
    ) {
      edges {
        node {
          data {
            index
            question {
              text
            }
            answer {
              richText
            }
          }
        }
      }
    }
    allPrismicTestimonial(
      limit: 2
      filter: {
        lang: { eq: $locale }
        data: { show_on_pages: { elemMatch: { page: { eq: $currentPage } } } }
      }
    ) {
      nodes {
        id
        data {
          fact_large {
            text
          }
          fact_small {
            text
          }
          logo {
            url
            alt
          }
          title {
            text
          }
        }
        uid
      }
    }
  }
`
